// extracted by mini-css-extract-plugin
export default {"header":"Header_header__EKYrg","container":"Header_container__bAiaa","text":"Header_text__nikg8","link":"Header_link__6zRBL"};